import { UserManager, WebStorageStateStore, type User } from 'oidc-client-ts';
import { config } from '../config';

export interface SigninState {
  returnTo: string;
}

export const userManager = new UserManager({
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: `${config.origin}/auth-callback`,
  post_logout_redirect_uri: `${config.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  // Keycloak выдаёт одноразовые refresh-токены: обновляемся по refresh_token без iframe.
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  extraQueryParams: { ui_locales: 'ru' },
});

const currentPath = () => window.location.pathname + window.location.search + window.location.hash;

export function login(returnTo: string = currentPath()): Promise<void> {
  const state: SigninState = { returnTo };
  return userManager.signinRedirect({ state });
}

export function logout(): Promise<void> {
  return userManager.signoutRedirect();
}

/** Смена своего пароля на странице Keycloak. */
export function changePassword(): Promise<void> {
  const state: SigninState = { returnTo: currentPath() };
  return userManager.signinRedirect({
    state,
    extraQueryParams: { ui_locales: 'ru', kc_action: 'UPDATE_PASSWORD' },
  });
}

export async function getAccessToken(): Promise<string | null> {
  const user = await userManager.getUser();
  if (!user || user.expired) return null;
  return user.access_token;
}

let silentInFlight: Promise<User | null> | null = null;

/** Тихое обновление токена; параллельные вызовы делят один запрос. */
export function renewSilently(): Promise<User | null> {
  if (!silentInFlight) {
    silentInFlight = userManager
      .signinSilent()
      .catch(() => null)
      .finally(() => {
        silentInFlight = null;
      });
  }
  return silentInFlight;
}
